var _circle, _g, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCircularWhite = function SvgIconCircularWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_circular_white_svg__a",
    width: 10,
    height: 10,
    x: 1,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_circular_white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    d: "M1.982 9.733a8 8 0 0 0-.197.777c-.113.541.313.99.865.99h7c.553 0 1.004-.449.954-.999-.042-.454-.115-.89-.235-1.04-.469-.59-.825-.648-1.314-.85-.328-.136-.631-.225-.94-.375-.239-.115-.72-.355-.72-.641l.056-.535c0-.144 0-.305.166-.695.276-.066.405-.379.498-.736.037-.144.11-.661 0-.716a.44.44 0 0 0-.22-.053h-.002c.04-.192 0-.435 0-.633 0-.229-.065-.819-.243-.99-.381-.369-.521-.466-1.03-.614-.47-.137-.845-.137-1.05-.107-.626.091-.985.409-1.328.962-.079.127-.166.54-.166.642 0 .39.055.479.166.77a.31.31 0 0 0-.26.15c-.096.161-.157.45-.082.826.06.297.415.646.618.646.132.481.23.459.388.762.044.086.055.285.055.374-.205.33-.467.68-.83.856-.628.303-1.4.456-1.918.957-.085.082-.188.161-.23.272Z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.5,
    stroke: "#fff"
  })));
};
export default SvgIconCircularWhite;